export default {
	namespaced: true,

	state: {},

	actions: {
		fetchOrderByVisitId ({ commit }, { visitId }) {
			return window.axios.get(`/order/visit/${visitId}`).then(({ data }) => {
				return data
			})
		},
		create({ commit }, { order }) {
			return window.axios.post('/order', order).then(({ data }) => data)
		},

		update({ commit }, { id, order }) {
			return window.axios.put(`/order/${id}`, order).then(({ data }) => data)
		}
	},

	mutations: {},

	getters: {}
}